import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Add Features"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-4" }, "List Feature", -1)
const _hoisted_6 = { class: "row g-4" }
const _hoisted_7 = { class: "p-3 border rounded-2" }
const _hoisted_8 = { class: "form-check fv-row" }
const _hoisted_9 = ["checked", "indeterminate", "onChange"]
const _hoisted_10 = ["for"]
const _hoisted_11 = { class: "form-check mt-4" }
const _hoisted_12 = ["checked", "onChange"]
const _hoisted_13 = ["for"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, " Close ", -1)

import ApiService from "@/core/services/ApiService";
import {
  onMounted,
  reactive,
  ref,
  onBeforeMount,
} from "vue";
import { useRouter } from "vue-router";
import { useToast } from "vue-toastification";
import { Modal } from "bootstrap";
import { SelectedFeature } from "@/components/1crm/fitur/model/MasterPricing";


export default /*#__PURE__*/_defineComponent({
  props: {
  dataValue: {
    type: Array,
  },
},
  emits: ["save"],
  setup(__props, { emit }) {

const props = __props


const toast = useToast();
const router = useRouter();
const tableData = ref<SelectedFeature[]>([]);
const isLoading = ref(false);
const name = ref("");
let myModal = null;
const modalElement = ref(null);
const selectedFeatures = reactive<SelectedFeature[]>([]);


const getData = () => {
  let search = "";
  if (name.value) {
    search = "feature_name=" + name.value + "&";
  } else {
    search;
  }
  ApiService.getWithoutSlug("crmv2/main_feature/feature-master/search?")
    .then(({ data }) => {
      tableData.value = data.data;
      isLoading.value = false;
    })
    .catch((e) => {
      if (e.response.status == 401) {
        toast.error(e.response.data.detail);
        router.push("/sign-in");
        isLoading.value = false;
      } else {
        toast.error(e.response.data.detail);
        isLoading.value = false;
      }
    });
};

const handleSave = () => {
  closeModal();
  emit("save", selectedFeatures);
};

function getFeatureIndex(fid) {
  return selectedFeatures.findIndex((f) => f.feature_id === fid);
}

function isFeatureChecked(fid) {
  const index = getFeatureIndex(fid);
  if (index === -1) return false;
  return (
    selectedFeatures[index].feature_status === true &&
    selectedFeatures[index].detail_modules.every((m) => m.module_status)
  );
}

function isFeatureIndeterminate(fid) {
  const index = getFeatureIndex(fid);
  if (index === -1) return false;
  const modules = selectedFeatures[index].detail_modules;
  const checked = modules.filter((m) => m.module_status).length;
  return checked > 0 && checked < modules.length;
}

function isModuleChecked(fid, mid) {
  const fIdx = getFeatureIndex(fid);
  if (fIdx === -1) return false;
  return selectedFeatures[fIdx].detail_modules.some(
    (m) => m.module_key === mid && m.module_status
  );
}

function onFeatureToggle(feature) {
  const fIdx = getFeatureIndex(feature._id);
  const isSelected = fIdx !== -1 && selectedFeatures[fIdx].feature_status;

  if (isSelected) {
    selectedFeatures.splice(fIdx, 1);
  } else {
    selectedFeatures.push({
      feature_id: feature._id,
      name: feature.feature_name,
      feature_status: true,
      detail_modules: feature.detail_modules.map((mod) => ({
        ...mod,
        module_status: true,
      })),
    });
  }
}

function onModuleToggle(feature, module) {
  const fIdx = getFeatureIndex(feature._id);

  if (fIdx === -1) {
    selectedFeatures.push({
      feature_id: feature._id,
      feature_name: feature.feature_name,
      feature_status: false,
      detail_modules: feature.detail_modules.map((mod) => ({
        ...mod,
        module_status: mod.module_key === module.module_key,
      })),
    });
  } else {
    const featureData = selectedFeatures[fIdx];
    const moduleIdx = featureData.detail_modules.findIndex(
      (m) => m.module_key === module.module_key
    );

    // Toggle status module
    featureData.detail_modules[moduleIdx].module_status =
      !featureData.detail_modules[moduleIdx].module_status;

    // Update feature_status
    const allChecked = featureData.detail_modules.every((m) => m.module_status);
    const noneChecked = featureData.detail_modules.every(
      (m) => !m.module_status
    );

    featureData.feature_status = allChecked;

    if (noneChecked) {
      selectedFeatures.splice(fIdx, 1);
    }
  }
}

const openModal = () => {
  if (myModal) {
    myModal.show();
  }
};
const closeModal = () => {
  if (myModal) {
    myModal.hide();
  }
};

onMounted(() => {
  if (modalElement.value) {
    // Inisialisasi modal Bootstrap dan simpan instance-nya
    myModal = new Modal(modalElement.value);
  }
  selectedFeatures.splice(0); // kosongkan dulu

  props.dataValue?.forEach((feature: any) => {
    selectedFeatures.push({
      feature_id: feature.feature_id,
      feature_name: feature.name, // diubah dari 'name'
      name: feature.name, // diubah dari 'name'
      feature_status: feature.feature_status,
      detail_modules: feature.detail_modules.map((mod) => ({
        module_key: mod.module_key,
        module_description: mod.module_description,
        module_status: mod.module_status,
      })),
    });
  });
});

onBeforeMount(() => {
  getData();
  console.log("props value", props.dataValue);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "btn btn-info",
      type: "button",
      onClick: openModal
    }, " Add Feature "),
    _createElementVNode("div", {
      class: "modal",
      tabindex: "-1",
      id: "add-feature-modal",
      ref: (_value, _refs) => {
        _refs['modalElement'] = _value
        modalElement.value = _value
      }
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableData.value, (items, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "col-4"
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        checked: isFeatureChecked(items._id),
                        indeterminate: isFeatureIndeterminate(items._id),
                        onChange: ($event: any) => (onFeatureToggle(items))
                      }, null, 40, _hoisted_9),
                      _createElementVNode("label", {
                        class: "form-check-label",
                        for: `${items.feature_name} ${index}`
                      }, _toDisplayString(items.feature_name), 9, _hoisted_10)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.detail_modules, (detailModule, indexModule) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "ms-3 row-columns",
                        key: indexModule
                      }, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            checked: 
                          isModuleChecked(items._id, detailModule.module_key)
                        ,
                            onChange: ($event: any) => (onModuleToggle(items, detailModule))
                          }, null, 40, _hoisted_12),
                          _createElementVNode("label", {
                            class: "form-check-label",
                            for: `${detailModule}-${indexModule}`
                          }, _toDisplayString(detailModule.module_key), 9, _hoisted_13)
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", { class: "modal-footer" }, [
            _hoisted_14,
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: handleSave
            }, " Save changes ")
          ])
        ])
      ])
    ], 512)
  ], 64))
}
}

})